
export default function FormModalButton() {
    return (
        <>
            <a className="formButton" href="/form">Descarga nuestro catálogo de productos</a>
        </>
    );
}
